import React from 'react';
import { FlatList } from 'native-base';
import { ProductListProps } from '~/pages/shop/components/ProductList';
import { ProductListPageProps, useDutchieStore } from '@springbig/shared';
import { useAppNavigate } from '~/pages';
import { Button } from '~/shared/Theme';

export const CategoriesList = () => {

    const { setProductListProps, menuCategories, isBusy } = useDutchieStore();
    const { navigate, params } = useAppNavigate();

    return (
        <FlatList
            horizontal={true}
            px={4}
            pb={3}
            data={menuCategories.filter(category => category.displayCategory)}
            renderItem={({ item } : { item: ProductListProps }) =>

                <Button
                    mr={2}
                    text={item.title}
                    modifier={'small'}
                    disabled={isBusy}
                    onPress={() => {

                        const productListProps: ProductListPageProps = {
                            title: item.title,
                            category: item.category,
                            subCategory: item.subcategory,
                            menuSection: item.menuSection,
                        };
                        setProductListProps(productListProps);
                        navigate(`w/${params.wallet_id}/shop/product_list`);
                    }}
                />
            }
        />
    );
};
